var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1C1C1A",
  fillRule: "evenodd",
  d: "M.146 12.354a.5.5 0 0 0 .708 0L8 5.207l7.146 7.147a.5.5 0 0 0 .708-.708L8 3.793.146 11.646a.5.5 0 0 0 0 .708",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export { SvgChevronUp as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzgxN185NzU3KSI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMC4xNDY0NDcgMTIuMzUzNkMwLjM0MTcwOSAxMi41NDg4IDAuNjU4MjkxIDEyLjU0ODggMC44NTM1NTMgMTIuMzUzNkw4IDUuMjA3MTFMMTUuMTQ2NCAxMi4zNTM2QzE1LjM0MTcgMTIuNTQ4OCAxNS42NTgzIDEyLjU0ODggMTUuODUzNiAxMi4zNTM2QzE2LjA0ODggMTIuMTU4MyAxNi4wNDg4IDExLjg0MTcgMTUuODUzNiAxMS42NDY0TDggMy43OTI4OUwwLjE0NjQ0NyAxMS42NDY0Qy0wLjA0ODgxNTQgMTEuODQxNyAtMC4wNDg4MTU1IDEyLjE1ODMgMC4xNDY0NDcgMTIuMzUzNloiIGZpbGw9IiMxQzFDMUEiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF84MTdfOTc1NyI+CjxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";